module.exports = __webpack_public_path__ + "img/Store-Locator-Address-Mgmt.edb7da55.png";